import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_hot-rod-coatings/artifacts/5wdtui8p_MARTENS%20MOTOR%20CO%20with%20thunder_no%20specialty%20coatings.png";

export default function Footer() {
  return (
    <footer
      className="bg-zinc-950 border-t border-white/10"
      data-testid="footer">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Tagline */}
          <div className="md:col-span-1">
            <Link to="/">
              <img
                src={LOGO_URL}
                alt="Martens Motor Co."
                className="h-16 w-auto mb-4" />

            </Link>
            <p className="text-zinc-400 font-body text-sm leading-relaxed">
              Building legends, one ride at a time.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-xl text-white mb-4 tracking-wide">
              NAVIGATE
            </h4>
            <ul className="space-y-2">
              {["Home", "Services", "Gallery", "About", "Contact"].map((item) =>
              <li key={item}>
                  <Link
                  to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                  className="text-zinc-400 hover:text-amber-500 font-body text-sm transition-colors duration-200">

                    {item}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-xl text-white mb-4 tracking-wide">
              SERVICES
            </h4>
            <ul className="space-y-2">
              {["Custom Builds", "Specialty Coatings", "Custom Paint", "Metal Fabrication & Custom Bodywork", "3D Design & Parts Fabrication"].map((item) =>
              <li key={item}>
                  <Link
                  to="/services"
                  className="text-zinc-400 hover:text-amber-500 font-body text-sm transition-colors duration-200">

                    {item}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-xl text-white mb-4 tracking-wide">
              GET IN TOUCH
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-zinc-400">
                <MapPin size={18} className="text-amber-500 flex-shrink-0" />
                <span className="font-body text-sm">Chilliwack, BC</span>
              </li>
              <li className="flex items-center gap-3 text-zinc-400">
                <Phone size={18} className="text-amber-500 flex-shrink-0" />
                <a href="tel:778-344-4374" className="font-body text-sm hover:text-amber-500 transition-colors">778-344-4374</a>
              </li>
              <li className="flex items-center gap-3 text-zinc-400">
                <Mail size={18} className="text-amber-500 flex-shrink-0" />
                <a href="mailto:martensmotorco@gmail.com" className="font-body text-sm hover:text-amber-500 transition-colors">martensmotorco@gmail.com</a>
              </li>
              <li className="flex items-center gap-3 text-zinc-400">
                <Instagram size={18} className="text-amber-500 flex-shrink-0" />
                <button
                  onClick={() => window.open('https://instagram.com/martensmotorco', '_blank', 'noopener,noreferrer')}
                  className="font-body text-sm hover:text-amber-500 transition-colors">

                  @martensmotorco
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 font-mono text-xs">
            &copy; {new Date().getFullYear()} MARTENS MOTOR CO. ALL RIGHTS RESERVED.
          </p>
          <div className="flex items-center gap-6">
            <button
              onClick={() => window.open('https://instagram.com/martensmotorco', '_blank', 'noopener,noreferrer')}
              className="text-zinc-400 hover:text-amber-500 transition-colors"
              data-testid="footer-instagram">

              <Instagram size={20} />
            </button>
          </div>
        </div>
      </div>
    </footer>);

}